import axios from 'axios';

const url = '/api/v1/profiles/me/personal_details';

export function setInvestorType(typeId) {
  return axios.post(`${url}/investor_type_id`, { value: typeId });
}

export function setEmail(email) {
  return axios.post(`${url}/email`, { value: email });
}

export function setPassword(password) {
  return axios.post(`${url}/password`, { value: password });
}

export function getIncompleteDetails() {
  return axios.get(`${url}/incomplete_details`);
}

export function setFirstName(name) {
  return axios.post(`${url}/first_name`, { value: name });
}

export function setLastName(name) {
  return axios.post(`${url}/last_name`, { value: name });
}

export function setOrganisation(org) {
  return axios.post(`${url}/organisation`, { value: org });
}

export function setPosition(pos) {
  return axios.post(`${url}/position`, { value: pos });
}

export function setDob(timestamp) {
  return axios.post(`${url}/date_of_birth`, { value: timestamp });
}

export function getDetails() {
  return axios.get(url);
}

export function removePicture() {
  return axios.post(`${url}/_remove_profile_picture`);
}

export function updatePicture(file) {
  const data = new FormData();
  data.append('profile_picture', file);
  const options = { headers: { 'content-type': 'multipart/form-data' } };
  return axios.post(`${url}/_update_profile_picture`, data, options);
}
